<template>
    <transition name="fade">
        <div class="moduleList" v-if="data.length > 0">
            <div class="moduleTitle">
                <span>{{ title || moduleTypeLabel[listType]['moduleTitle'] }}</span>
                <span class="allBtn" @click="openList()" v-if="!pageName">全部<i></i></span>
                <span class="filter" v-if="pageName == 'list'" @click="orderModel = true"><i></i>{{ order.optionLabel
                }}</span>
            </div>
            <div class="list">
                <div class="listTh">
                    <div class="rank" v-for="label  in moduleTypeLabel[listType]['tdLabel']">{{ label }}</div>
                </div>
                <div class="listItem" v-for="item  in data" @click="goToDetail(item)">
                    <template v-for="(label, index) in moduleTypeLabel[listType]['dataField']">
                        <div class="tableCell itemImg" v-if="index == 0">
                            <img :src="item[label]" :onerror="defaultImg" alt="">
                            <p class="weaponName">
                                {{ item[moduleTypeLabel[listType]['weaponNameCNField']] ||
                                    item[moduleTypeLabel[listType]['weaponNameField']] }}
                            </p>
                        </div>
                        <div class="tableCell" v-else>{{ item[label] }}</div>

                    </template>
                </div>
            </div>
            <transition>
                <van-popup v-model="orderModel" get-container="#app" round position="bottom" :safe-area-inset-bottom="true"
                    :style="{ maxHeight: '80%', height: '307px', borderRadius: '6px' }">
                    <div class="filterWeapon">
                        <div class="popupTitle">
                            <div class="titleText">排序</div>
                            <div class="closeIcon" @click="orderModel = false"></div>
                        </div>
                        <div class="popupBody">
                            <div class="weaponsList">
                                <div class="weapons">
                                    <div class="weaponMenu" :class="{ cur: plat.optionLabel == order.optionLabel }"
                                        v-for="plat in moduleTypeLabel[listType]['filterOpitons']" :key="plat.optionLabel"
                                        @click="addplat(plat)">
                                        {{ plat.optionLabel }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-popup>
            </transition>
        </div>
    </transition>
</template>
<script>
import { Popup } from "vant";

export default {
    name: "ModuleList",
    components: { Popup },
    props: {
        pageName: '',
        listType: '',
        data: [],
        title:'',
        filterMethod: Function,
    },
    data() {
        return {
            order: {
                optionLabel: '击杀',
                optionValue: 'kills'
            },
            orderModel: false,
            moduleTypeLabel: {
                'weapon': {
                    moduleTitle: '武器',
                    tdLabel: [
                        '武器',
                        '击杀',
                        'KPM',
                        'DPM',
                        '准度'
                    ],
                    dataField: [
                        'weaponImageUrl', 'kills', 'kpm', 'dpm', 'accuracy'
                    ],
                    weaponNameCNField: 'nameCn',
                    weaponNameField: 'name',
                    filterOpitons: [
                        {
                            optionLabel: '击杀',
                            optionValue: 'klls',
                            isDefault: true,
                        },
                        {
                            optionLabel: 'KPM',
                            optionValue: 'kpm',
                            isDefault: false,
                        },

                        {
                            optionLabel: 'DPM',
                            optionValue: 'dpm',
                            isDefault: false,
                        },
                        {
                            optionLabel: '准度',
                            optionValue: 'accuracy',
                            isDefault: false,
                        },
                        {
                            optionLabel: '使用时长',
                            optionValue: 'usedTime',
                            isDefault: false,
                        }

                    ]
                },
                'classes': {
                    moduleTitle: '专家',
                    tdLabel: [
                        '专家',
                        '击杀',
                        'KPM',
                        'KDA',
                        '使用时长'
                    ],
                    dataField: [
                        'statImageUrl', 'kills', 'kpm', 'kd', 'usedTimeStr'
                    ],
                    weaponNameCNField: 'nameCn',
                    weaponNameField: 'name',
                    filterOpitons: [
                        {
                            optionLabel: '击杀',
                            optionValue: 'klls',
                            isDefault: true,
                        },
                        {
                            optionLabel: 'KPM',
                            optionValue: 'kpm',
                            isDefault: false,
                        },
                        {
                            optionLabel: 'KDA',
                            optionValue: 'kd',
                            isDefault: false
                        },
                        {
                            optionLabel: '使用时长',
                            optionValue: 'usedTime',
                            isDefault: false,
                        }
                    ]
                },
                'vehicle': {
                    moduleTitle: '载具',
                    tdLabel: [
                        '载具',
                        '击杀',
                        'KPM',
                        '摧毁数量',
                        '使用时长',
                    ],
                    dataField: [
                        'vehicleImageUrl', 'kills', 'kpm', 'destroyed', 'usedTimeStr'
                    ],
                    weaponNameCNField: 'nameCn',
                    weaponNameField: 'name',
                    filterOpitons: [
                        {
                            optionLabel: '击杀',
                            optionValue: 'klls',
                            isDefault: true,
                        },
                        {
                            optionLabel: 'KPM',
                            optionValue: 'kpm',
                            isDefault: false
                        },
                        {
                            optionLabel: '摧毁数量',
                            optionValue: 'destroyed',
                            isDefault: false,
                        },
                        {
                            optionLabel: '使用时长',
                            optionValue: 'usedTime',
                            isDefault: false,
                        },

                    ]
                },
                'gadget': {
                    moduleTitle: '特殊武器',
                    tdLabel: [
                        '特殊武器',
                        '击杀',
                        'KPM',
                        'DPM',
                        '使用次数'
                    ],
                    dataField: [
                        'gadgetImageUrl', 'kills', 'kpm', 'dpm', 'uses'
                    ],
                    weaponNameCNField: 'nameCn',
                    weaponNameField: 'name',
                    filterOpitons: [
                        {
                            optionLabel: '击杀',
                            optionValue: 'klls',
                            isDefault: true
                        },
                        {
                            optionLabel: 'KPM',
                            optionValue: 'kpm',
                            isDefault: false
                        },
                        {
                            optionLabel: 'DPM',
                            optionValue: 'dpm',
                            isDefault: false
                        },
                        {
                            optionLabel: '使用次数',
                            optionValue: 'uses',
                            isDefault: false
                        }
                    ]
                },
                'weaponGroup': {
                     moduleTitle: '武器类型',
                    tdLabel: [
                        '类型',
                        '击杀',
                        'KPM',
                        'DPM',
                        '准度'
                    ],
                    dataField: [
                        'imageUrl', 'kills', 'kpm', 'dpm', 'accuracy'
                    ],
                    weaponNameCNField: 'nameCn',
                    weaponNameField: 'name',
                    filterOpitons: [
                        {
                            optionLabel: '击杀',
                            optionValue: 'klls',
                            isDefault: true,
                        },
                        {
                            optionLabel: 'KPM',
                            optionValue: 'kpm',
                            isDefault: false,
                        },

                        {
                            optionLabel: 'DPM',
                            optionValue: 'dpm',
                            isDefault: false,
                        },
                        {
                            optionLabel: '准度',
                            optionValue: 'accuracy',
                            isDefault: false,
                        },
                        {
                            optionLabel: '使用时长',
                            optionValue: 'usedTime',
                            isDefault: false,
                        }

                    ]
                },
                'vehicleGroup': {
                    moduleTitle: '载具类型',
                    tdLabel: [
                        '类型',
                        '击杀',
                        'KPM',
                        '摧毁数量',
                        '使用时长'
                    ],
                    dataField: [
                        'imageUrl', 'kills', 'kpm', 'destroyed', 'usedTimeStr'
                    ],
                    weaponNameCNField: 'nameCn',
                    weaponNameField: 'name',
                    filterOpitons: [
                        {
                            optionLabel: '击杀',
                            optionValue: 'klls',
                            isDefault: true,
                        },
                        {
                            optionLabel: 'KPM',
                            optionValue: 'kpm',
                            isDefault: false
                        },
                        {
                            optionLabel: '摧毁数量',
                            optionValue: 'destroyed',
                            isDefault: false,
                        },
                        {
                            optionLabel: '使用时长',
                            optionValue: 'usedTime',
                            isDefault: false,
                        },

                    ]
                },
                'gameMode':{
                    moduleTitle: '游戏模式',
                    tdLabel: [
                        '比赛',
                        '击杀',
                        'KPM',
                        '胜率',
                        '总场数'
                    ],
                    dataField: [
                        'imageUrl', 'kills', 'kpm', 'winPercent', 'matches'
                    ],
                    weaponNameCNField: 'nameCn',
                    weaponNameField: 'name',
                    filterOpitons: [
                        {
                            optionLabel: '使用时长',
                            optionValue: 'usedTime',
                            isDefault: true,
                        },
                        {
                            optionLabel: '击杀',
                            optionValue: 'kills',
                            isDefault: false
                        },
                        {
                            optionLabel: 'KPM',
                            optionValue: 'kpm',
                            isDefault: false
                        },
                        {
                            optionLabel: '胜率',
                            optionValue: 'winPercent',
                            isDefault: false,
                        },
                        {
                            optionLabel: '总场数',
                            optionValue: 'matches',
                            isDefault: false,
                        },

                    ]
                },
                'mapMode': {
                    moduleTitle: '地图列表',
                    tdLabel: [
                        '地图',
                        '场次',
                        '胜率',
                        '胜场数',
                        '游玩时长'
                    ],
                    dataField: [
                        'imageUrl', 'matches', 'winPercent', 'wins', 'usedTimeStr'
                    ],
                    weaponNameCNField: 'nameCn',
                    weaponNameField: 'name',
                    filterOpitons: [
                        {
                            optionLabel: '使用时长',
                            optionValue: 'usedTime',
                            isDefault: false,
                        },
                        {
                            optionLabel: '场次',
                            optionValue: 'matches',
                            isDefault: true
                        },
                       
                        {
                            optionLabel: '胜率',
                            optionValue: 'winPercent',
                            isDefault: false,
                        },
                         {
                            optionLabel: '胜场数',
                            optionValue: 'wins',
                            isDefault: false
                        },

                    ]
                }
            },
            list: [''],
            isList: false,
            defaultImg: 'this.src="' + require('../../assets/image/battlefield/img_zjwu.png') + '"',



        };
    },
    mounted() {
        if (this.$store.state.order) {
            const label = this.moduleTypeLabel[this.listType]['filterOpitons'].filter(i => i.optionValue == this.$store.state.order)
            if (label.length > 0) {
                this.order = label[0]

            }

        }
    },
    methods: {
        addplat(plat) {
            this.order = plat;
            this.orderModel = false;
            this.$store.commit("setStateData", {
                state: "order",
                data: plat.optionValue,
            });
            this.filterMethod()
        },
        openList() {
            this.$utils.openWithNewWindow(this.$utils.getCurrentUrl() + "battleFieldList.html", { gsAppChannelParams: this.listType, battlefield2042UserName: this.$store.state.battlefield2042UserName, })

        },
        goToDetail(item) {
            this.$utils.openWithNewWindow(this.$utils.getCurrentUrl() + 'battleFieldDetail.html', {
                weaponName: item['name'],
                weaponType: this.listType,
                battlefield2042UserName: this.$store.state.battlefield2042UserName,
            })
        }

    },
};
</script>
<style lang="scss" scoped>
@function getMaxWidth($maxWidth) {
  @if (max-width > $maxWidth) {
    @return $maxWidth;
  } @else {
    @return max-width;
  }
}
.moduleList {
    margin: 12px 0 20px 0;
    color: #fff;

    .moduleTitle {
        margin-bottom: 12px;
        height: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 15px;
        color: rgba(255, 255, 255, 0.5);

        .allBtn {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.5);

            i {
                display: inline-block;
                width: 10px;
                height: 10px;
                background: url('../../assets/image/battlefield/icon_ LinearArrowRight.png') no-repeat center / 10px;
            }
        }

        .filter {
            font-size: 13px;
            color: rgba(255, 255, 255, 0.5);
            display: flex;
            align-items: center;

            i {
                margin-right: 2px;
                display: inline-block;
                width: 14px;
                height: 14px;
                background: url('../../assets/image/battlefield/icon_sort.png') no-repeat center / 14px;
            }
        }
    }

    .list {
        .listTh {
            width: 100%;
            display: flex;
            margin-top: 4px;
            margin-bottom: 8px;

            &::after {
                margin-left: 4px;
                display: inline-block;
                visibility: hidden;
                width: 8px;
                height: 8px;
                content: '';
                background: url('../../assets/image/battlefield/icon_\ LinearArrowRight.png') no-repeat center / 8px 8px;
            }

            .rank {
                text-align: left;
                font-size: 10px;
                line-height: 12px;
                color: rgba(255, 255, 255, 0.3);
                 margin-right: 8px;
                box-sizing: border-box;

                &:first-child {
                    margin-right: 19px;
                    width: 90px;
                    text-align: center;
                }

                &:nth-child(2) {
                    width: calc((100vw - 87px) * 52 / 288);
                }

                &:nth-child(3) {
                    width: calc((100vw - 87px) * 42 / 288);
                }

                &:nth-child(4) {
                    width: calc((100vw - 87px) * 52 / 288);
                }

                &:nth-child(5) {
                    width: calc((100vw - 87px) * 52 / 288);
                     margin-right: 0;

                }

                img {
                    border: 0.5px solid rgba(255, 255, 255, 0.05);
                }
            }

        }

        .listItem {
            height: 44px;
            display: flex;
            
            align-items: center;
            margin-bottom: 8px;

            &::after {
                margin-left: 4px;
                display: inline-block;
                width: 8px;
                height: 8px;
                content: '';
                background: url('../../assets/image/battlefield/icon_\ LinearArrowRight.png') no-repeat center / 8px 8px;
            }

            .tableCell {
                text-align: left;
                color: rgba(255, 255, 255, 0.8);
                font-size: 12px;
                opacity: .8;
                word-break: keep-all;
                text-overflow: ellipsis;
                overflow: hidden;
                margin-right: 8px;
                box-sizing: border-box;

                &:first-child {
                    margin-right: 19px;
                    width: 90px;
                    height: 44px;
                    border: 0.5px solid rgba(255, 255, 255, 0.10);
                    border-radius: 4px;
                    text-align: center;

                }

                &:nth-child(2) {
                    width: calc((100vw - 87px) * 52 / 288);
                    line-height: 44px;

                }

                &:nth-child(3) {
                    width: calc((100vw - 87px)  *  42 / 288);
                    line-height: 44px;

                }

                &:nth-child(4) {
                    width: calc((100vw - 87px) * 52 / 288);
                    line-height: 44px;

                }

                &:nth-child(5) {
                    width: calc((100vw - 87px)  *  52 / 288);
                    line-height: 44px;
                    margin-right: 0;


                }

                .weaponName {
                    margin-top: -6px;
                    font-size: 10px;
                    color: rgba(255, 255, 255, 0.5);
                    max-width: 90px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                }
            }

            img {
                width: 62px;
                height: 30px;
                opacity: .6;
            }
        }
    }


}

.filterWeapon {
    color: #ffffff;
    padding: 17px 0px 5px;

    .popupTitle {
        font-size: 15px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-weight: bold;
        line-height: 22px;
        padding: 0 16px;
        margin-bottom: 5px;

        .closeIcon {
            width: 16px;
            height: 16px;
            background: url("//image.gamersky.com/webimg13/db/diablo4/assets/skillInfoClose-icon.png") no-repeat center / 100%;
        }
    }

    .popupBody {
        margin-top: -3px;
        padding-bottom: 30px;
        max-height: 413px;
        overflow: scroll;
    }

    .weaponBox {
        &:first-child {
            .weaponType {
                margin-top: 16px;
            }
        }
    }

    .weaponType {
        margin-top: 19px;
        font-size: 12px;
        color: #717173;
        line-height: 16px;
    }

    .weaponsList {
        padding: 0 16px;
    }

    .weapons {
        margin-top: 11px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 8px;

        .weaponMenu {
            height: 28px;
            border-radius: 2px;
            overflow: hidden;
            background-color: #2e2e33;
            font-size: 12px;
            color: #d7d7d9;
            text-align: center;
            line-height: 28px;
            transition: all 0.2s;
            overflow: hidden;
            text-overflow: ellipsis;
            box-sizing: border-box;

            &.cur {
                background-color: #d7d7d9;
                color: #222226;
            }
        }
    }
}
</style>
